import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isFetching, getIsFetchingOrderDetails } from './reducer';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { NoResults } from '../../components';
import LoadingMessage from '../../components/spinner/LoadingMessage';

import ReturnDetailProductCard from './ReturnDetailProductCard';

import { filterObject } from '../../util/filterListNested';

export const ReturnDetailsProducts = ({
  products,
  productDetails,
  currencyCode,
  searchTerm,
  isFetching,
  isFetchingOrderDetails,
  isGreaterChinaSalesOrg
}) => {
  const filteredProducts = products?.filter(product => product.quantity > 0);
  const sizeDataByProductCode = {};
  filteredProducts?.forEach(product => {
    const size = productDetails?.[product.productCode]?.sizes.find(size => size.code === product.sizeCode);
    if (!sizeDataByProductCode[product.productCode]) {
      sizeDataByProductCode[product.productCode] = [
        { ...size, quantity: product.quantity, receivedQty: product.receivedQty }
      ];
    } else {
      sizeDataByProductCode[product.productCode].push({
        ...size,
        quantity: product.quantity,
        receivedQty: product.receivedQty
      });
    }
  });

  const hasSubRSOs = products?.some(product => product.receivedQty > 0) || false;

  return (
    <div className='returnDetails__products prl3-xl'>
      {isFetching || isFetchingOrderDetails ? (
        <LoadingMessage title={new TranslatedCopy({ id: 'global.products' }).toString()} />
      ) : (
        <>
          {filteredProducts?.length > 0 ? (
            Object.entries(sizeDataByProductCode).reduce((productCards, [productCode, sizeData]) => {
              const fullProductDetails = { productCode, ...productDetails[productCode] };
              const quantity = sizeData.reduce((count, size) => count + (size.quantity || 0), 0);
              const receivedQty = sizeData.reduce((count, size) => count + (size.receivedQty || 0), 0);

              if (!searchTerm || filterObject(fullProductDetails, ['copy.name', 'productCode'], searchTerm)) {
                productCards.push(
                  <ReturnDetailProductCard
                    key={productCode}
                    product={{ productCode, quantity, receivedQty, ...productDetails[productCode] }}
                    currencyCode={currencyCode}
                    isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
                    sizeData={sizeData}
                    hasSubRSOs={hasSubRSOs}
                  />
                );
              }
              return productCards;
            }, [])
          ) : (
            <NoResults titleId='orderreturns.noProducts' />
          )}
        </>
      )}
    </div>
  );
};

ReturnDetailsProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  productDetails: PropTypes.object.isRequired,
  currencyCode: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isFetchingOrderDetails: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isFetching: isFetching(state),
  isFetchingOrderDetails: getIsFetchingOrderDetails(state)
});

const connector = connect(mapStateToProps, {});

export default connector(ReturnDetailsProducts);
